import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';


const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./common/common.module').then(m => m.AppCommonModule),
  },

  {
    path: '**',
    loadChildren: () =>
      import('./shared/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
